import {
    getServer,
    postServer,
    putServer,
    deleteServer,
} from "@services/server";
import i18n from "@/i18n";

const state = {
    loading: false,
    serverData: [],
    serverHeader: [
        { text: "ID", value: "id", align: "left", width: "30px" },
        {
            text: i18n.t("common.table.brokerName"),
            value: "broker_name",
            align: "left",
            width: "110px",
        },
        {
            text: i18n.t("common.table.serverName"),
            value: "server_name",
            align: "left",
            width: "110px",
        },
        {
            text: i18n.t("common.table.adapterID"),
            value: "adapter_id",
            align: "left",
            width: "110px",
        },
        {
            text: i18n.t("common.table.description"),
            value: "description",
            align: "left",
            width: "140px",
        },
        {
            text: i18n.t("common.table.host"),
            value: "host",
            align: "left",
            width: "110px",
        },
        {
            text: i18n.t("common.table.port"),
            value: "port",
            align: "left",
            width: "60px",
        },
        {
            text: i18n.t("common.table.createdAt"),
            value: "created_at",
            align: " d-none",
            width: "100px",
        },
        {
            text: i18n.t("common.table.updatedAt"),
            value: "updated_at",
            align: " d-none",
            width: "100px",
        },
        {
            text: i18n.t("common.table.actions"),
            value: "action",
            align: "left",
            width: "100px",
        },
    ],
    updated: false,
    csvFields: {
        ID: "id",
        "Broker ID": "broker_id",
        "Broker Name": "broker_name",
        "Server Name": "server_name",
        "Adapter ID": "adapter_id",
        Description: "description",
        Host: "host",
        Port: "port",
    },
};

const actions = {
    getServerAction({ commit }, params) {
        commit("UPDATE_STATUS", false);
        commit("UPDATE_LOADING", true);
        getServer().then((res) => {
            let resortedData = [];
            res.data.map((item) => {
                if (item.server_name.toLowerCase().includes("demo")) {
                    resortedData.push(item);
                } else {
                    resortedData.unshift(item);
                }
            });
            commit("UPDATE_SERVER", resortedData);
            commit("UPDATE_LOADING", false);
        });
    },
    postServerAction({ commit }, params) {
        commit("UPDATE_LOADING", true);
        postServer(params)
            .then((res) => {
                let snackbar = {
                    message: res.data.msg,
                    color: "green",
                    btnName: "Close",
                    status: true,
                    timeout: 2000,
                };
                commit("UPDATE_SNACKBAR", snackbar, { root: true });
                commit("UPDATE_LOADING", false);
                commit("UPDATE_STATUS", true);
            })
            .catch((e) => {
                commit("UPDATE_LOADING", false);
            });
    },
    /**
     * Update broker server
     * @param   {[type]}  commit  [commit description]
     * @param   {[type]}  params  [params description]
     * @return  {[type]}          [return description]
     */
    putServerAction({ commit }, params) {
        commit("UPDATE_LOADING", true);
        putServer(params)
            .then((res) => {
                let snackbar = {
                    message: res.data.msg,
                    color: "green",
                    btnName: "Close",
                    status: true,
                    timeout: 2000,
                };
                commit("UPDATE_SNACKBAR", snackbar, { root: true });
                commit("UPDATE_LOADING", false);
                commit("UPDATE_STATUS", true);
            })
            .catch((e) => {
                commit("UPDATE_LOADING", false);
            });
    },
    deleteServerAction({ commit }, params) {
        commit("UPDATE_LOADING", true);
        deleteServer(params)
            .then((res) => {
                let snackbar = {
                    message: res.data.msg,
                    color: "green",
                    btnName: "Close",
                    status: true,
                    timeout: 2000,
                };
                commit("UPDATE_SNACKBAR", snackbar, { root: true });
                commit("UPDATE_LOADING", false);
                commit("UPDATE_STATUS", true);
            })
            .catch(({ response }) => {
                if (response.status == 406) {
                    let snackbar = {
                        message:
                            response.data.msg +
                            i18n.t("settings.server.deleteWarning"),
                        color: "red",
                        btnName: "Close",
                        status: true,
                        timeout: 4000,
                    };
                    commit("UPDATE_SNACKBAR", snackbar, { root: true });
                    commit("UPDATE_LOADING", false);
                }
            });
    },
};

const mutations = {
    /**
     * Update server
     *
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_SERVER(state, data) {
        state.serverData = data;
    },
    /**
     * Update loading
     *
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_LOADING(state, data) {
        state.loading = data;
    },
    UPDATE_STATUS(state, data) {
        state.updated = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
